module.exports = __webpack_public_path__ + "img/interpackmaxi_dfod.5e20098a.png";